import {faPlus} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button, Group} from '@mantine/core';
import {PartnerSitesService} from '../api/generated/PartnerSitesService';
import {
  PagedDataTableConfig,
  renderEditButton,
  usePagedDataTable,
} from '../hooks/paged-data-table/use-paged-data-table';
import {BasicPage} from '../components/basic-page';
import {Link} from 'react-router-dom';
import {ROUTES} from '../routes';

const RuntimeConfig = {
  renderActions: (
    <Button component={Link} to={ROUTES.ADMIN.PARTNER_SITES.CREATE.path}>
      <Group gap='xs'>
        <FontAwesomeIcon icon={faPlus} /> New Partner Site
      </Group>
    </Button>
  ),
};

export const PartnerSitesListing = () => {
  const pagedDataTable = usePagedDataTable(
    PartnerSitesService.getAll,
    TableConfig,
    RuntimeConfig,
  );

  return <BasicPage title='Partner Sites'>{pagedDataTable}</BasicPage>;
};

const TableConfig = PagedDataTableConfig(PartnerSitesService.getAll, {
  columns: [
    {
      accessor: '',
      title: '',
      render: (item) =>
        renderEditButton({
          item: {...item, id: Number(item.id)},
          descriptor: 'partner site',
          route: ROUTES.ADMIN.PARTNER_SITES.DETAIL.path,
        }),
    },
    {
      accessor: 'name',
      title: 'Site Name',
      sortable: true,
    },
    {
      accessor: 'arfNumber',
      title: 'ARF Number',
      sortable: true,
    },
    {
      accessor: 'timeDifference',
      title: 'Time Difference',
      sortable: true,
    },
    {
      accessor: 'city',
      title: 'City',
      sortable: true,
    },
    {
      accessor: 'state',
      title: 'State',
      sortable: true,
    },
    {
      accessor: 'sortOrder',
      title: 'Sort Order',
    },
    {
      accessor: 'inactive',
      title: 'Status',
      render: (item) => (item.inactive ? 'Inactive' : 'Active'),
    },
  ],
  defaultSort: {
    column: 'sortOrder',
    direction: 'ASC',
  },
  searchFieldNames: ['name', 'arfNumber', 'city', 'state'],
});
